export default __webpack_public_path__ + "static/media/proximanova-light-webfont.eb9fe596.woff2";